import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23a45f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "ss-imagem" }
const _hoisted_7 = {
  role: "button",
  tabindex: "0",
  class: "ant-upload ant-upload-btn"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ant-upload-drag-icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text" }, "Por favor, aguarde...", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-upload-drag-icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ant-upload-text ss-descricao-nova-logo" }, "Clique aqui ou arraste a imagem", -1))
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-5 ant-col-xl-10" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Número Série")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-10" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Vencimento")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1))
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_17 = { class: "ant-col ant-col-xs-4 ant-col-xl-10" }
const _hoisted_18 = { class: "ant-col ant-col-xs-2 ant-col-xl-4" }
const _hoisted_19 = { class: "ss-margin-campos" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_36 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_37 = { class: "ant-input-group-addon" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_39 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_40 = { class: "ant-input-group-addon" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_49 = { class: "ant-row" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Assunto", -1))
const _hoisted_60 = { style: {"width":"400px"} }
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Corpo", -1))
const _hoisted_64 = { style: {"width":"400px"} }
const _hoisted_65 = { class: "ant-row" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_68 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_69 = { class: "ant-row" }
const _hoisted_70 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_71 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_72 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_74 = { class: "ant-row" }
const _hoisted_75 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_76 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_77 = { class: "ant-row" }
const _hoisted_78 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_79 = { class: "ant-row" }
const _hoisted_80 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Assunto", -1))
const _hoisted_82 = { style: {"width":"400px"} }
const _hoisted_83 = { class: "ant-row" }
const _hoisted_84 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Corpo", -1))
const _hoisted_86 = { style: {"width":"400px"} }
const _hoisted_87 = { class: "ant-row" }
const _hoisted_88 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_89 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_90 = { class: "ant-row" }
const _hoisted_91 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_92 = { class: "ant-row" }
const _hoisted_93 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_94 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_95 = { class: "ant-row" }
const _hoisted_96 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_97 = { class: "ant-row" }
const _hoisted_98 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Assunto", -1))
const _hoisted_100 = { style: {"width":"400px"} }
const _hoisted_101 = { class: "ant-row" }
const _hoisted_102 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Corpo", -1))
const _hoisted_104 = { style: {"width":"400px"} }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_106 = [
  _hoisted_105
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_selecionar_ambiente_d_fe = _resolveComponent("selecionar-ambiente-d-fe")!
  const _component_selecionar_tipo_emissao_n_fe = _resolveComponent("selecionar-tipo-emissao-n-fe")!
  const _component_selecionar_variavel_documento_fiscal_eletronico = _resolveComponent("selecionar-variavel-documento-fiscal-eletronico")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_selecionar_tipo_emissao_n_f_ce = _resolveComponent("selecionar-tipo-emissao-n-f-ce")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_tipo_emitente_m_d_fe = _resolveComponent("selecionar-tipo-emitente-m-d-fe")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    centered: "",
    style: {"width":"950px"},
    "wrap-class-name": "ss-modal-cadastros scroll-modal"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Configuração de Documentos Fiscais Eletrônicos")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_card, { titulo: "LOGO" }, {
                    default: _withCtx(() => [
                      (_ctx.UtilitarioGeral.valorValido(_ctx.state.configuracao.contratante.logo))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, [
                              _createVNode(_component_a_image, {
                                height: "125",
                                style: {"max-height":"125px!important"},
                                src: _ctx.state.configuracao.contratante.logo
                              }, null, 8, ["src"])
                            ]),
                            (_ctx.UtilitarioGeral.valorValido(_ctx.state.configuracao.contratante.logo))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  title: "Remover",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.excluirLogo())),
                                  class: "ss-remover-logo"
                                }, "Remover"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selecionarLogoUpload && _ctx.selecionarLogoUpload(...args))),
                            class: "ant-upload ant-upload-drag",
                            onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                            onDrop: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            _createElementVNode("span", _hoisted_7, [
                              _createElementVNode("input", {
                                id: "selecionarLogoDocumentoFiscalEletronico",
                                type: "file",
                                accept: "",
                                multiple: "",
                                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enviarImagens && _ctx.enviarImagens(...args))),
                                style: {"display":"none"}
                              }, null, 32),
                              _createElementVNode("div", {
                                class: "ant-upload-drag-container",
                                onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dropImagem && _ctx.dropImagem(...args)))
                              }, [
                                ((_ctx.state.enviandoLogo))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createElementVNode("p", _hoisted_9, [
                                        _createVNode(_component_a_spin, { size: "large" })
                                      ]),
                                      _hoisted_10
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createElementVNode("p", _hoisted_12, [
                                        _createVNode(_component_icone, {
                                          style: {"font-size":"35px"},
                                          nome: "upload-nuvem"
                                        })
                                      ]),
                                      _hoisted_13
                                    ]))
                              ], 32)
                            ])
                          ], 32))
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.state.enviandoCertificado,
                    tip: "Enviando o seu Ceritificado..."
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card, { titulo: "CERTIFICADOS" }, {
                        AcoesExtra: _withCtx(() => [
                          _createElementVNode("a", {
                            class: "ss-fonte-negrito ss-card-botao-acao-extra",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selecionarCertificadoUpload()))
                          }, "ENVIAR CERTIFICADO"),
                          (_openBlock(), _createElementBlock("input", {
                            key: 'cert-' + _ctx.state.keyCertificados,
                            id: "selecionarCertificadoDocumentoFiscalEletronico",
                            type: "file",
                            accept: "",
                            multiple: "",
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.preparaEnvioCeritificado && _ctx.preparaEnvioCeritificado(...args))),
                            style: {"display":"none"}
                          }, null, 32))
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.UtilitarioGeral.validaLista(_ctx.state.configuracao.certificados))
                            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                key: 0,
                                mensagem: "Nenhum certificado adicionado ainda."
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_15,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.configuracao.certificados, (certificado, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ant-row ss-grade-personalizada-linha",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("span", null, _toDisplayString(certificado.numeroSerie), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(certificado.dataVencimento)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ant-btn ant-btn-secondary ss-botao-remover",
                                          style: {"width":"100%"},
                                          title: "Remover",
                                          onClick: ($event: any) => (_ctx.removerCertificado(index))
                                        }, [
                                          _createVNode(_component_icone, {
                                            class: "ss-icone-remover",
                                            nome: "excluir"
                                          })
                                        ], 8, _hoisted_20)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ], 64))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ])
              ]),
              _createVNode(_component_a_collapse, {
                accordion: "",
                class: "ss-accordion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "RESPONSÁVEL TÉCNICO"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        class: "ss-margin-campos",
                        checked: _ctx.state.configuracao.contratante.informarResponsavelTecnico,
                        "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.configuracao.contratante.informarResponsavelTecnico) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Informar Responsável Técnico ")
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      ((_ctx.state.configuracao.contratante.informarResponsavelTecnico))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_a_form_item, {
                                  label: "CNPJ",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_cnpj, {
                                      valor: _ctx.state.configuracao.responsavelTecnico.cnpj,
                                      "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.cnpj) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_a_form_item, {
                                  label: "Contato",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "ant-input",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.contato) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.configuracao.responsavelTecnico.contato]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_a_form_item, {
                                  label: "Telefone",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_telefone, {
                                      modelValue: _ctx.state.configuracao.responsavelTecnico.telefone,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.telefone) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_a_form_item, {
                                  label: "E-mail",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "ant-input",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.email) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.configuracao.responsavelTecnico.email]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode(_component_a_divider, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Informações fornecidas pela SEFAZ")
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_a_form_item, {
                                  label: "Identificador CSRT",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "ant-input",
                                      type: "number",
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.identificadorCsrt) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.configuracao.responsavelTecnico.identificadorCsrt]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_a_form_item, {
                                  label: "Hash CSRT",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "ant-input",
                                      type: "text",
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.configuracao.responsavelTecnico.hashCsrt) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.configuracao.responsavelTecnico.hashCsrt]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_collapse_panel, {
                    key: "2",
                    header: "SERVIDOR SMTP"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_a_form_item, {
                            label: "Servidor",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.configuracao.servidorSmtp.servidor) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.configuracao.servidorSmtp.servidor]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_a_form_item, {
                            label: "Porta",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "6",
                                class: "ant-input",
                                style: {"text-align":"right"},
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.configuracao.servidorSmtp.porta) = $event)),
                                onKeypress: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validarInformacaoDigitada($event))),
                                onPaste: _cache[19] || (_cache[19] = ($event: any) => (_ctx.validarInformacaoColada($event)))
                              }, null, 544), [
                                [_vModelText, _ctx.state.configuracao.servidorSmtp.porta]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_a_form_item, {
                            label: "SSL",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_sim_nao, {
                                valor: _ctx.state.configuracao.servidorSmtp.ssl,
                                "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.configuracao.servidorSmtp.ssl) = $event)),
                                radioButton: true
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_a_form_item, {
                            label: "E-mail",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_36, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    nome: "email"
                                  })
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.configuracao.servidorSmtp.email) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.configuracao.servidorSmtp.email]
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_a_form_item, {
                            label: "Senha",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, [
                                  _createVNode(_component_icone, {
                                    class: "ss-icone",
                                    nome: "senha"
                                  })
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "password",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.configuracao.servidorSmtp.senha) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.configuracao.servidorSmtp.senha]
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_card, { titulo: "DOCUMENTOS FISCAIS" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tabs, {
                        defaultActiveKey: _ctx.state.abaAtiva
                      }, {
                        default: _withCtx(() => [
                          ((_ctx.props.limitesDocumentosFiscais.limiteQuantidadeNFe > 0))
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "1",
                                tab: "NF-e"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Ambiente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_ambiente_d_fe, {
                                            valor: _ctx.state.configuracao.configuracaoNFe.ambiente,
                                            "onUpdate:valor": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.ambiente) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Tipo Emissão",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_tipo_emissao_n_fe, {
                                            valor: _ctx.state.configuracao.configuracaoNFe.tipoEmissao,
                                            "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.tipoEmissao) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Configurações DANFE")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            class: "ss-margin-campos",
                                            checked: _ctx.state.configuracao.configuracaoNFe.imprimirNomeFantasiaEmitente,
                                            "onUpdate:checked": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.imprimirNomeFantasiaEmitente) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Imprimir Nome Fantasia do Emitente")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            class: "ss-margin-campos",
                                            checked: _ctx.state.configuracao.configuracaoNFe.quebrarLinhaProduto,
                                            "onUpdate:checked": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.quebrarLinhaProduto) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Quebrar Linha Produto ")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  (_ctx.state.configuracao.configuracaoNFe.ambiente === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_a_divider, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Monitoramento DF-e")
                                          ]),
                                          _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_49, [
                                          _createElementVNode("div", _hoisted_50, [
                                            _createVNode(_component_a_form_item, {
                                              label: "Monitorar Notas Contra CNPJ",
                                              class: "ss-margin-campos"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_selecionar_sim_nao, {
                                                  radioButton: true,
                                                  valor: _ctx.state.configuracao.monitorarNotasContraCnpj,
                                                  "onUpdate:valor": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.configuracao.monitorarNotasContraCnpj) = $event)),
                                                  onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.state.configuracao.alterouInformacoesMonitoramento = true))
                                                }, null, 8, ["valor"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createElementVNode("div", _hoisted_51, [
                                            _createVNode(_component_a_form_item, {
                                              label: "NSU Inicial",
                                              class: "ss-margin-campos"
                                            }, {
                                              default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "ant-input",
                                                  type: "number",
                                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.configuracao.nsuInicial) = $event)),
                                                  onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.state.configuracao.alterouInformacoesMonitoramento = true)),
                                                  disabled: !_ctx.state.configuracao.monitorarNotasContraCnpj
                                                }, null, 40, _hoisted_52), [
                                                  [_vModelText, _ctx.state.configuracao.nsuInicial]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createElementVNode("div", _hoisted_53, [
                                            _createVNode(_component_a_form_item, {
                                              label: "Último NSU",
                                              class: "ss-margin-campos"
                                            }, {
                                              default: _withCtx(() => [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "ant-input",
                                                  type: "number",
                                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.configuracao.ultimoNsu) = $event)),
                                                  onInput: _cache[32] || (_cache[32] = ($event: any) => (_ctx.state.configuracao.alterouInformacoesMonitoramento = true)),
                                                  disabled: !_ctx.state.configuracao.monitorarNotasContraCnpj
                                                }, null, 40, _hoisted_54), [
                                                  [_vModelText, _ctx.state.configuracao.ultimoNsu]
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Modelo E-mail")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.configuracaoNFe.enviarEmail,
                                        "onUpdate:checked": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.enviarEmail) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Enviar E-mails")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"]),
                                      ((_ctx.state.configuracao.configuracaoNFe.enviarEmail))
                                        ? (_openBlock(), _createBlock(_component_card, {
                                            key: 0,
                                            titulo: "INFORMAÇÕES DO E-MAIL"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_57, [
                                                _createElementVNode("div", _hoisted_58, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_59,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_60, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelAssuntoNFe && _ctx.adicionarVariavelAssuntoNFe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no Assunto"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "ant-input",
                                                        maxlength: "250",
                                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.assuntoEmail) = $event))
                                                      }, null, 512), [
                                                        [_vModelText, _ctx.state.configuracao.configuracaoNFe.assuntoEmail]
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_61, [
                                                _createElementVNode("div", _hoisted_62, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_63,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_64, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelCorpoNFe && _ctx.adicionarVariavelCorpoNFe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no corpo do E-mail"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_editor_html, {
                                                        value: _ctx.state.configuracao.configuracaoNFe.corpoEmail,
                                                        "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.corpoEmail) = $event))
                                                      }, null, 8, ["value"]),
                                                      _createElementVNode("button", {
                                                        class: "ant-btn ant-btn-secondary",
                                                        onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.restaurarTemplateEmailNFe && _ctx.restaurarTemplateEmailNFe(...args)))
                                                      }, "Restaurar Modelo Padrão")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.props.limitesDocumentosFiscais.limiteQuantidadeNFCe > 0))
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "2",
                                tab: "NFC-e"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Ambiente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_ambiente_d_fe, {
                                            valor: _ctx.state.configuracao.configuracaoNFCe.ambiente,
                                            "onUpdate:valor": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.ambiente) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Tipo Emissão",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_tipo_emissao_n_f_ce, {
                                            valor: _ctx.state.configuracao.configuracaoNFCe.tipoEmissao,
                                            "onUpdate:valor": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.tipoEmissao) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_68, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Impressão Resumida",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_sim_nao, {
                                            radioButton: true,
                                            valor: _ctx.state.configuracao.configuracaoNFCe.impressaoResumida,
                                            "onUpdate:valor": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.impressaoResumida) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Credenciamento SEFAZ")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("div", _hoisted_70, [
                                      _createVNode(_component_a_form_item, {
                                        label: "ID Token",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "ant-input",
                                            type: "text",
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.idToken) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.configuracao.configuracaoNFCe.idToken]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createVNode(_component_a_form_item, {
                                        label: "CSC",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "ant-input",
                                            type: "text",
                                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.csc) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.configuracao.configuracaoNFCe.csc]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  ((_ctx.state.configuracao.configuracaoNFCe.tipoEmissao === 9))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, [
                                          _createVNode(_component_card, { titulo: "INFORMAÇÕES CONTIGÊNCIA" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_74, [
                                                _createElementVNode("div", _hoisted_75, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Data Hora de Ativacão",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_selecionar_data, {
                                                        horaMinutoSegundo: true,
                                                        data: _ctx.state.configuracao.configuracaoNFCe.dataHoraAtivacaoContigencia,
                                                        "onUpdate:data": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.dataHoraAtivacaoContigencia) = $event))
                                                      }, null, 8, ["data"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_76, [
                                                  _createVNode(_component_a_form_item, {
                                                    label: "Justificativa",
                                                    class: "ss-margin-campos"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _withDirectives(_createElementVNode("input", {
                                                        class: "ant-input",
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.justificativaContigencia) = $event))
                                                      }, null, 512), [
                                                        [_vModelText, _ctx.state.configuracao.configuracaoNFCe.justificativaContigencia]
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Modelo E-mail")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.configuracaoNFe.enviarEmail,
                                        "onUpdate:checked": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFe.enviarEmail) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Enviar E-mails")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"]),
                                      ((_ctx.state.configuracao.configuracaoNFe.enviarEmail))
                                        ? (_openBlock(), _createBlock(_component_card, {
                                            key: 0,
                                            titulo: "INFORMAÇÕES DO E-MAIL"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_79, [
                                                _createElementVNode("div", _hoisted_80, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_81,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_82, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelAssuntoNFCe && _ctx.adicionarVariavelAssuntoNFCe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no Assunto"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "ant-input",
                                                        maxlength: "250",
                                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.assuntoEmail) = $event))
                                                      }, null, 512), [
                                                        [_vModelText, _ctx.state.configuracao.configuracaoNFCe.assuntoEmail]
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_83, [
                                                _createElementVNode("div", _hoisted_84, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_85,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_86, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelCorpoNFCe && _ctx.adicionarVariavelCorpoNFCe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no corpo do E-mail"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_editor_html, {
                                                        value: _ctx.state.configuracao.configuracaoNFCe.corpoEmail,
                                                        "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFCe.corpoEmail) = $event))
                                                      }, null, 8, ["value"]),
                                                      _createElementVNode("button", {
                                                        class: "ant-btn ant-btn-secondary",
                                                        onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.restaurarTemplateEmailNFCe && _ctx.restaurarTemplateEmailNFCe(...args)))
                                                      }, "Restaurar Modelo Padrão")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.props.limitesDocumentosFiscais.limiteQuantidadeMDFe > 0))
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "3",
                                tab: "MDF-e"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("div", _hoisted_88, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Ambiente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_ambiente_d_fe, {
                                            valor: _ctx.state.configuracao.configuracaoMDFe.ambiente,
                                            "onUpdate:valor": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.state.configuracao.configuracaoMDFe.ambiente) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_89, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Tipo Emitente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_tipo_emitente_m_d_fe, {
                                            valor: _ctx.state.configuracao.configuracaoMDFe.tipoEmitente,
                                            "onUpdate:valor": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.state.configuracao.configuracaoMDFe.tipoEmitente) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Credenciamento ANTT")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_90, [
                                    _createElementVNode("div", _hoisted_91, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Código RNTRC",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "ant-input",
                                            type: "number",
                                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.state.configuracao.configuracaoMDFe.codigoRntrc) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.state.configuracao.configuracaoMDFe.codigoRntrc]
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          ((_ctx.props.limitesDocumentosFiscais.limiteQuantidadeNFSe > 0))
                            ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: "4",
                                tab: "NFS-e"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("div", _hoisted_93, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Ambiente",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_ambiente_d_fe, {
                                            valor: _ctx.state.configuracao.configuracaoNFSe.ambiente,
                                            "onUpdate:valor": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFSe.ambiente) = $event))
                                          }, null, 8, ["valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            checked: _ctx.state.configuracao.configuracaoNFSe.enviarEmail,
                                            "onUpdate:checked": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFSe.enviarEmail) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Enviar E-mails")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _createVNode(_component_a_divider, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Modelo E-mail")
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                      ((_ctx.state.configuracao.configuracaoNFSe.enviarEmail))
                                        ? (_openBlock(), _createBlock(_component_card, {
                                            key: 0,
                                            titulo: "INFORMAÇÕES DO E-MAIL"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_97, [
                                                _createElementVNode("div", _hoisted_98, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_99,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_100, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event)),
                                                              nfse: true
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelAssuntoNFSe && _ctx.adicionarVariavelAssuntoNFSe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no Assunto"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "ant-input",
                                                        maxlength: "250",
                                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFSe.assuntoEmail) = $event))
                                                      }, null, 512), [
                                                        [_vModelText, _ctx.state.configuracao.configuracaoNFSe.assuntoEmail]
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_101, [
                                                _createElementVNode("div", _hoisted_102, [
                                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                                    label: _withCtx(() => [
                                                      _hoisted_103,
                                                      _createVNode(_component_a_popover, {
                                                        placement: "top",
                                                        title: "Adicionar Variável",
                                                        trigger: "click"
                                                      }, {
                                                        content: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_104, [
                                                            _createVNode(_component_selecionar_variavel_documento_fiscal_eletronico, {
                                                              valor: _ctx.state.variavelSelecionada,
                                                              "onUpdate:valor": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event)),
                                                              nfse: true
                                                            }, null, 8, ["valor"]),
                                                            _createElementVNode("button", {
                                                              class: "ant-btn ant-btn-secondary",
                                                              onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelCorpoNFSe && _ctx.adicionarVariavelCorpoNFSe(...args)))
                                                            }, "Adicionar")
                                                          ])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_icone, {
                                                            class: "ss-icone-informacao-campo",
                                                            nome: "informacoes-fp",
                                                            title: "Adicionar variável no corpo do E-mail"
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_editor_html, {
                                                        value: _ctx.state.configuracao.configuracaoNFSe.corpoEmail,
                                                        "onUpdate:value": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.state.configuracao.configuracaoNFSe.corpoEmail) = $event))
                                                      }, null, 8, ["value"]),
                                                      _createElementVNode("button", {
                                                        class: "ant-btn ant-btn-secondary",
                                                        onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.restaurarTemplateEmailNFSe && _ctx.restaurarTemplateEmailNFSe(...args)))
                                                      }, "Restaurar Modelo Padrão")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["defaultActiveKey"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_a_modal, {
                visible: _ctx.state.apresentarModalSenha,
                "onUpdate:visible": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.state.apresentarModalSenha) = $event)),
                centered: "",
                title: "Digite a senha do seu Certificado Digital"
              }, {
                closeIcon: _withCtx(() => [
                  _createVNode(_component_icone, { nome: "voltar" })
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                      onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.enviarCertificado && _ctx.enviarCertificado(...args)))
                    }, _hoisted_106)
                  ])
                ]),
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    class: "ant-input",
                    type: "text",
                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.state.senhaCertificado) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.senhaCertificado]
                  ])
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
        retornoRequisicao: _ctx.modalBase.retornoRequisicao
      }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
    ]),
    _: 1
  }, 8, ["visible"]))
}